import classNames from 'classnames';
import React from 'react';

import { StoryNumberListData } from '@/pages/numberSystem/setNumberTable/table';

import { getNumberDesc } from '../../util';
import styles from './index.module.less';


export const defaultValue = { optionName: '', missionId: '' };

export const MultiCardContainerDesc: React.FC<
{
  actionCondErrorMsg?: string;
  numChangeErrorMsg?: string;
  val: any,
  storyNumber: {
    storyNumberList: StoryNumberListData[];
    storyNumberLoading: boolean;
  }

}
> = (props) => {
  const { actionCondErrorMsg, numChangeErrorMsg, val, storyNumber } = props;
  return (
    <div className={styles.collapseDesc} >
      {
        val?.openCollapse !== true && val?.useOptionCond === true
          ? <div className={styles.content}>
            <div>
              <div className={styles.closeDesc}>
                <div className={styles.closeDescLeft}>激活选项条件</div>
                {
                  val?.optionCond?.activationCond?.length > 0
                    ? <div className={styles.closeDescRight} >
                      {storyNumber?.storyNumberLoading
                        ? '数据加载中'
                        : getNumberDesc(val?.optionCond?.activationCond, storyNumber?.storyNumberList)?.map((e, i) => (<span key={i}>{e}</span>))
                      }
                    </div>
                    : <div className={classNames(styles.closeDescRight, styles.toSetting)} >
                      去设置
                    </div>
                }
              </div>
              {
                actionCondErrorMsg ? <div className={styles.errorMsg}>{actionCondErrorMsg}</div> : null
              }
            </div>
            <div>
              <div className={styles.closeDesc}>
                <div className={styles.closeDescLeft}>选后数值变化</div>
                {
                  val?.optionCond?.numChange?.length > 0
                    ? <div className={styles.closeDescRight} >
                      {storyNumber?.storyNumberLoading
                        ? '数据加载中'
                        : getNumberDesc(val?.optionCond?.numChange, storyNumber?.storyNumberList)?.map((e, i) => (<span key={i}>{e}</span>))
                      }
                    </div>
                    : <div className={classNames(styles.closeDescRight, styles.toSetting)} >
                      去设置
                    </div>
                }
              </div>
              {
                numChangeErrorMsg ? <div className={styles.errorMsg}>{numChangeErrorMsg}</div> : null
              }
            </div>
          </div>
          : null
      }
    </div>
  );
};
